export FoodTruckCatering from './FoodTruckCatering'
export SaveTime from './SaveTime'
export SitBackRelax from './SitBackRelax'
export RepeatRepeat from './RepeatRepeat'
export MakeEveryoneHappy from './MakeEveryoneHappy'
export WhyWorkWithUs from './WhyWorkWithUs'
export CateringForAnyEvent  from './CateringForAnyEvent'
export HowItWorks from './HowItWorks'
export HowItWorksLarge from './HowItWorksLarge'
export FeaturedClients from './FeaturedClients'
export TagList from './TagList'
export CuisineTypes from './CuisineTypes'
